<script>
  import getTranslation from '../../utilities/getTranslation';
  import { createEventDispatcher, onMount } from 'svelte';

  const dispatch = createEventDispatcher();
  export let cards, active, data, navbarTopPosition;

  const navbarTopPositionStyle = `--navbarTopPosition: ${navbarTopPosition}rem`;
  const subscriptionCards = data.firstRow.productGroups.length;

  let navElement;

  const goToActiveCard = (i) => {
    const card = cards[i];
    dispatch('cardSelected', {
      card,
    });
  };

  let spaceUntilShowNavbar = 0;

  onMount(() => {
    const oneRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    spaceUntilShowNavbar = navbarTopPosition * oneRem;
  });

  $: show = false;
  const onScroll = () => {
    const y = window.pageYOffset;
    const height = navElement.offsetHeight;
    const top = navElement.offsetTop;

    show = y > top - spaceUntilShowNavbar && y < top + height;
  };
</script>

<style lang="scss">
  @use './index' as *;

  nav {
    position: fixed;
    top: var(--navbarTopPosition);
    z-index: 2;
    left: 0;
    right: 0;
    width: 100%;
    overflow: hidden;
    // Delay visibility transition so it kicks in after opacity
    transition: visibility 0s ease-in 0.2s, opacity 0.2s ease-in;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;

    &.show {
      pointer-events: all;
      visibility: visible;
      opacity: 1;
      // Unset visibility transition delay when transitioning
      // from "not shown" -> "shown"
      // .show is immediately applied, and immediately removed when not shown
      transition-delay: 0s;
    }

    ul {
      background-color: $pink-20;
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      padding: 1rem;
      height: spacing(7);
      font-size: spacing(2);
      color: $purple-50;
      font-weight: bolder;
      overflow-y: scroll;

      /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none;
      scrollbar-width: none;

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }

      @include mq($from: tabletportrait) {
        justify-content: center;
      }

      li {
        width: 100%;
        cursor: pointer;
        white-space: nowrap;
        padding: 0 spacing(2);

        a {
          text-decoration: none;

          &.active {
            border-block-end: 0.2rem solid $purple-50;
            cursor: pointer;
          }
        }
      }

      &.ul-one-card {
        display: none;
      }

      &.ul-two-cards {
        @include mq($from: tabletlandscape) {
          display: none;
        }
      }

      &.ul-multiple-cards {
        @include mq($from: tabletlandscape) {
          display: none;
        }
      }

      &.ul-four-cards {
        display: flex;
        @include mq($from: desktop) {
          display: none;
        }
      }

      @include mq($from: desktop) {
        display: none;
      }
    }
  }
</style>

<div bind:this={navElement}><slot /></div>
<nav class:show aria-label="Select subscription" style={navbarTopPositionStyle}>
  <ul
    class="navigation"
    class:ul-one-card={subscriptionCards === 1}
    class:ul-two-cards={subscriptionCards === 2}
    class:ul-multiple-cards={subscriptionCards > 1}
    class:ul-four-cards={subscriptionCards >= 4}
  >
    {#each data.firstRow.productGroups as subscription, i}
      <li on:click|preventDefault={() => goToActiveCard(i)}>
        <a href={`#${subscription.name}`} value={subscription.id} class:active={i === active}
          >{getTranslation(subscription.informationKeys, 'description.title.v2')}</a
        >
      </li>
    {/each}
  </ul>
</nav>
<svelte:window on:scroll={onScroll} />
